import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    authorize: 'Authorize',
    cancel: 'Cancel',
    logout: 'Use a different account',
    title: '{0} wants to:',
  },
  fr: {
    authorize: 'Autoriser',
    cancel: 'Annuler',
    logout: 'Changer d’utilisateur',
    title: '{0} souhaite : ',
  },
});

export default locales;
